import {USER_CHANGE} from './types';

export default function (id, name, type) {
    return {
        type: USER_CHANGE,
        payload: {id, name, type},
        meta: {dialog: 'Show confirm!!!'}
    };
}


/** WEBPACK FOOTER **
 ** ./src/modules/food/actions/UserChange.js
 **/